import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FeaturesEvaluation } from '@app/pages/dashboard/pages/automations/models/entitlements.enum';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EntitlementsService {
  /**
   * HTTP options for the requests
   */
  private httpOptions: any = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
    }),
  };

  /** URL for the API */
  private urlApi = environment.url_api;

  /**
   * Constructor
   * @param http HttpClient
   */
  constructor(private http: HttpClient) {}

  /** Get user entitlements context
   * @returns An observable containing the user entitlements context
   **/
  getEntitlementsContext(): Observable<any> {
    return this.http.get(this.urlApi + 'user-entitlements/context', this.httpOptions);
  }

  /** Get user entitlements dashboard
   * @returns An observable containing the user entitlements for dashboard
   **/
  getEntitlementsDashboard(): Observable<any> {
    return this.http.get(this.urlApi + 'user-entitlements/dashboard', this.httpOptions);
  }

  /** Send an evaluation request for a specific feature key
   * @param featureKey The feature key to evaluate
   * @returns An observable containing the evaluation result
   **/
  entitlementsEvaluate(featureKey: FeaturesEvaluation, automationId?: string): Observable<any> {
    // eslint-disable-next-line object-property-newline
    const payload = automationId ? { featureKey, automationId } : { featureKey };

    return this.http.post(this.urlApi + 'user-entitlements/evaluate', payload, this.httpOptions);
  }

  /** Send a public evaluation request for a specific feature key and owner
   * @param owner The owner of the feature
   * @param featureKey The feature key to evaluate
   * @returns An observable containing the evaluation result
   **/
  publicEvaluate(owner: string): Observable<any> {
    return this.http.post(
      this.urlApi + 'entitlements/public/evaluate',
      {
        owner,
        featureKey: FeaturesEvaluation.DOCUMENT_GENERATE_FORM,
      },
      this.httpOptions
    );
  }
}
